import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ProvisionRequest } from '../../api/provision-request-api.class';
import { ProvisionRequestApiService } from '../../api/provision-request-api.service';
import { inject } from '@angular/core';

export const provisionDetailResolver: ResolveFn<ProvisionRequest> = (
  route: ActivatedRouteSnapshot,
) => {
  return inject(ProvisionRequestApiService).getProvisionRequest(
    +route.paramMap.get('id')!,
  );
};
